// Action type -> Badge tone, shared by the calendar chips, the legend and the modal so
// a colour always means the same thing across the three.
const ACTION_TONES = {
  Installation: 'violet',
  'Démontage': 'amber',
  'Déplacement': 'blue',
  Maintenance: 'green',
};

export const actionTone = (requestType) => ACTION_TONES[requestType] || 'slate';
